export const authenticatedUser = () =>
  localStorage.getItem('userToken') !== null

export const parseJwt = () => {
  const base64Url = localStorage.getItem('userToken').split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

  return JSON.parse(window.atob(base64))
}
